if (customElements.get('slider-product') === undefined){
  class SliderProduct extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        slider_element: this,
        offsetParent: this.offsetParent
      };
      this.init();
    }
  
    connectedCallback() {
      if (Shopify.designMode) {
        this.onShopifySectionLoad = this.onSectionLoad.bind(this);
        this.onShopifySectionSelect = this.onSectionSelect.bind(this);
        this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
        document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
        document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
        document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
      }
    }
  
    disconnectedCallback() {
      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
        document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
        document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
      }
    }
  
    onSectionLoad(event) {
      filterShopifyEvent(event, this, () => this.initSlider());
    }
    onSectionSelect(event) {
      filterShopifyEvent(event, this, this.initSlider.bind(this));
    }
    onSectionDeselect(event) {
      filterShopifyEvent(event, this, this.initSlider.bind(this));
    }
  
    init() {
      if (Shopify && Shopify.designMode) {
        this.initSlider();
      }
  
      setTimeout(() => {
        this.initSlider();
      });
    }
  
    initSlider() {
      this.swiper = new Swiper(this.elements.slider_element, {
        slidesPerView: 2,
        spaceBetween: 7.5,
        freeMode: true,
        slideToClickedSlide: false,
        watchSlidesVisibility: true,
        resistance: true,
        resistanceRatio: 0.5,
        navigation: {
          nextEl: this.elements.offsetParent.querySelector(".swiper-button-next"),
          prevEl: this.elements.offsetParent.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: this.elements.offsetParent.querySelector('.swiper-pagination'),
          type: 'progressbar',
          draggable: true,
          hideOnClick: false
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
            freeMode: true,
            centeredSlides: true,
            centeredSlidesBounds: true
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 16,
            freeMode: true,
            centeredSlides: false,
            centeredSlidesBounds: false
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 16,
            freeMode: true,
            centeredSlides: false,
            centeredSlidesBounds: false
          },
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
          dragSize: 15
        },
        on: {
          init: function () {
            const ele = this.el.querySelector('.swiper-scrollbar');
            const elementHighLight = document.createElement('div');
            elementHighLight.className = 'swiper-scrollbar-highlight';
            ele.appendChild(elementHighLight);
            const scrollbarDragElement = this.el.querySelector('.swiper-scrollbar-drag');
            const newDiv = document.createElement('div');
            newDiv.className = 'minion';
            scrollbarDragElement.appendChild(newDiv);
          },
          lock: function () {
            const scrollbarCustom= this.el.querySelector('.swiper-scrollbar-custom');
            scrollbarCustom.style.display = 'none'
          }
        }
      });
      this.swiper.on('setTranslate', function (swiper, translate) {
        const translate3d = window.theme.getTranslate3d(swiper.scrollbar.dragEl)
        const width = translate3d[0] ?? 0;
        swiper.el.querySelector('.swiper-scrollbar-highlight').style.width = `${width}`;
      })
    }
  }
  
  customElements.define('slider-product', SliderProduct);
}